export default "__VITE_ASSET__BOr$AiJs__"